import React from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";
import PhoneTable from "./../../../public/images/PhoneTable";
export default function SLA() {
  const data = React.useMemo(
    () => [
      { condition: "If your breakage is unsignificant", number: 24 },
      { condition: "If your breakage is common", number: 6 },
      {
        condition:
          "If you breakage is significant (more than 3 devices are out of control)",
        number: 3,
      },
    ],
    [],
  );

  const columns = React.useMemo(
    () => [
      { header: "", accessorKey: "condition" },
      { header: <PhoneTable />, accessorKey: "number" },
    ],
    [],
  );

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });
  return (
    <div className="policyPage">
      <div className="policyPage__text">
        <h2>SLA</h2>
        <p>
          We are trying to provide the best experience to our clients and get in
          touch as soon as possible.
        </p>
        <p>
          We offer two types of SLA and offer certain rules for both of them.
        </p>
        <p>Type 1:   Direct SLA.</p>
        <p>Type 2:   General SLA.</p>
        <p>
          If you do not have a direct SLA agreement then there are the following
          rules:
        </p>
        <div className="policyPage__table">
          <table>
            <thead>
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => (
                    <th key={header.id}>
                      {flexRender(
                        header.column.columnDef.header,
                        header.getContext(),
                      )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.map((row) => (
                <tr key={row.id}>
                  {row.getVisibleCells().map((cell) => (
                    <td key={cell.id}>
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext(),
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="policyPage__image">
        <img src="/images/slaImage.png" alt="" />
      </div>
    </div>
  );
}
